/* src/components/center-modal/center-modal.component.scss */
:host {
  height: 100%;
  width: 100%;
}
.content-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-container .content {
  overflow: hidden;
}
/*# sourceMappingURL=center-modal.component.css.map */
